import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ISearchable } from 'src/app/common/contracts/components/searchable';
import { AttributeTemplateDto } from 'src/app/shared/models/general/attribute-template-dto.model';

import { IListView } from '../../../contracts/list-view';

@Component({
  selector: 'attribute-template-list-item',
  templateUrl: 'attribute-template-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AttributeTemplateItem implements IListView {
  @Input() item: AttributeTemplateDto;
  @Output() clicked: EventEmitter<ISearchable> = new EventEmitter<ISearchable>();

  triggerEvent() {
    this.clicked.emit(this.item);
  }
}
